import script from "./VipBenefits.vue?vue&type=script&setup=true&lang=js"
export * from "./VipBenefits.vue?vue&type=script&setup=true&lang=js"

import "./VipBenefits.vue?vue&type=style&index=0&id=36abab01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36abab01"]])

export default __exports__